module.exports = __webpack_public_path__ + "static/media/Placements.b02bf89e.png";